import React from "react";
import {

    Tabs,
    Tab,

} from "@mui/material";
import Transactions from "../Transactions/Transactions";
import Arrears from "../Arrears/Arrears";
import Notices from "../Notices/Notices";

const Account = (props) => {

    const [activeTab, setActiveTab] = React.useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };


    return (
        <>

            {/*<Grid item xs={15} md={8}>*/}
            {/* Tabs Section */}
            <Tabs
                value={activeTab}
                onChange={handleTabChange}
                textColor="primary"
                indicatorColor="primary"
                sx={{marginBottom: 2}}
            >
                <Tab label="Transactions"/>
                <Tab label="Arrears"/>
                <Tab label="Vacating Notice"/>
            </Tabs>

            {/* Tab Content */}
            {activeTab === 0 && (
                <Transactions tenantID={props.tenantID}/>
            )}

            {activeTab === 1 && (
                <Arrears tenantID={props.tenantID}/>
            )}

            {activeTab === 2 && (
                <Notices
                    tenantID={props.tenantID}
                    propertyID={props.propertyID}
                    tenantData={props.tenantData}
                    landlordId={props.landlordId}
                    onLeaseUpdated={props.onLeaseUpdated}
                />
            )}

        </>
    );
};

export default Account;
